import { Injectable, Scopes, ControllerProtocol } from '@visiba/instantiation';
import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { BookingScreen, ViewBookingAnalyticActions, ViewBookingController } from '../view_booking.controller';
import { BookingBasketService } from '../booking_basket.service';

@Injectable({
	scope: Scopes.Scoped,
})
export class ScreenRfvController implements ControllerProtocol {
	constructor(
		private readonly viewBookingController: ViewBookingController,
		private readonly analyticService: AnalyticService,
		private readonly bookingBasketService: BookingBasketService,
	) {}

	async whenMount() {
		this.analyticService.trackPageView({
			customTitle: 'Booking: Reason for visit',
		});

		this.bookingBasketService.unlockTimeSlot();

		if (!this.allowedToBeHere()) {
			this.analyticService.trackEvent(AnalyticCategories.Booking, ViewBookingAnalyticActions.NotAllowedToBeHere, 'Reason for visit');
			this.viewBookingController.goToScreen(BookingScreen.WhoIsRespondant, { replace: true });

			return;
		}

		const reasonForVisits = this.viewBookingController.getFilteredReasonForVisits();

		// Redirect to new screen if there are no reason for visits
		if (reasonForVisits.length === 0) {
			this.analyticService.trackEvent(AnalyticCategories.Booking, ViewBookingAnalyticActions.NoReasonForVisits);
			this.viewBookingController.goToScreen(BookingScreen.Location, { replace: true });

			return;
		}

		// Auto select reason for visit if there is only one, then redirect to new screen
		if (reasonForVisits.length === 1) {
			const reasonForVisit = reasonForVisits[0].Id;
			this.analyticService.trackEvent(
				AnalyticCategories.Booking,
				ViewBookingAnalyticActions.AutoSetReasonForVisit,
				`${reasonForVisit}`,
			);
			this.selectReasonForVisit(reasonForVisit, false);
			this.viewBookingController.goToScreen(BookingScreen.Location, { replace: true });

			return;
		}
	}

	public async selectReasonForVisit(reasonForVisitId: number, redirect = true) {
		this.analyticService.trackEvent(
			AnalyticCategories.Booking,
			ViewBookingAnalyticActions.SelectReasonForVisit,
			`${reasonForVisitId}`,
		);

		this.bookingBasketService.set({
			reasonForVisit: reasonForVisitId,
		});

		if (redirect) {
			this.viewBookingController.goToScreen(BookingScreen.Location);
		}
	}

	private allowedToBeHere() {
		// If we don't have flow data, we can't be here.
		const flowData = this.viewBookingController.flowData.peek().value;
		if (!flowData) {
			return false;
		}

		// If we don't have a selected respondent type, we can't be here.
		if (this.bookingBasketService.get().respondantType == null) {
			return false;
		}

		return true;
	}
}
